import React from 'react';
import Typography from '@material-ui/core/Typography';
import CustomTooltip from './CustomTooltip';

export default function ResponseTooltip({ payload, active }) {
    if (active && payload !== null) {
        const time = payload[0].payload;
        const setDate = (unix) => {
            const unixInMSecs = unix * 1000;
            const timezoneOffsetMSecs = new Date(unixInMSecs).getTimezoneOffset() * 60000;
            const day = new Date(unixInMSecs + timezoneOffsetMSecs)
            return `${day.getMonth() + 1}/${day.getDate()}`
        }
        const date = setDate(time.id)
        const sent = time.name;
        return (
            <CustomTooltip payload={payload} active={active}>
                <Typography component="p" >Sent: {sent}</Typography>
                <Typography component="p" >Duration: {time.duration} secs</Typography> 
            </CustomTooltip>
        )
    } else return null;
}



// WEBPACK FOOTER //
// ./src/components/ResponseTooltip.js